import { DataService } from '../services/data_service';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { renderText } from '../bereiche/dateneingabe/assistent/assistent_helpers';
import { TriggerService } from '../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../core/table/WFormsTableWrapper';
import { WSpinner } from '../core/elements/spinner/WSpinner';

interface KMUExterneFreigabeProps extends React.ClassAttributes<any> {
    containerId?: string;
    data: any;
}

interface KMUExterneFreigabeState extends React.ClassAttributes<any> {
    refreshStamp: number;
    dataRows: any[];
    showSpinner: boolean;
}

export class KMUExterneFreigabe extends React.Component<KMUExterneFreigabeProps, KMUExterneFreigabeState> {
    constructor(props: any) {
        super(props);
        this.state = {
            refreshStamp: 0,
            dataRows: [],
            showSpinner: false
        };
        this.onRowSelect = this.onRowSelect.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.loadData();
    }

    loadData() {
        this.setState({ showSpinner: true }, () => {
            this.dataService.loadData(IDs.ENT_EXTERNAL_ACCESS, undefined, undefined, (data: any) => {
                this.setState({ showSpinner: false });
                const extAccData = data[IDs.ENT_EXTERNAL_ACCESS] || [];
                const kennzData = this.props.data[IDs.KENNZIFFERN_STRUKTURIERT];
                const jahren: number[] = Object.keys(kennzData).filter((j: string) => Object.keys(kennzData[j]).length > 1).map((j: string) => +j);
                const curYear = new Date().getFullYear();
                if (jahren.indexOf(curYear) === -1) {
                    jahren.push(curYear);
                }
                if (jahren.indexOf(curYear - 1) === -1) {
                    jahren.push(curYear - 1);
                }
                jahren.sort();
                const dataRows: any[] = [];
                jahren.forEach((jahr: number) => {
                    const rowFnd = extAccData.find((r: any) => r.jahr === jahr);
                    if (rowFnd) {
                        rowFnd.datum_letzte_aenderung = rowFnd.datum_letzte_aenderung > 0 ?
                            Moment.unix(rowFnd.datum_letzte_aenderung).format('DD.MM.YYYY') : '';
                        dataRows.push(rowFnd);
                    } else {
                        dataRows.push({
                            tid: -jahr,
                            jahr,
                            freigegeben: 0
                        });
                    }
                });
                this.setState({ dataRows, refreshStamp: new Date().getTime() });
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }

    render() {
        const checkedRows: any = {};
        this.state.dataRows.filter((r: any) => r.freigegeben === 1).forEach((r: any) => checkedRows[r.tid] = true);
        const allCheckboxChecked = this.state.dataRows.length === Object.keys(checkedRows).length;
        return <div>
            <div key='text' style={{ padding: 5 }}>
                {renderText('hinweis_freigabe_kmu', this.props.data)}
            </div>
            <WFormsTableWrapper
                containerId={this.props.containerId}
                refreshStamp={this.state.refreshStamp}
                entity={IDs.ENT_EXTERNAL_ACCESS}
                module={IDs.MOD_ETOOL_ADMIN}
                data={this.state.dataRows}
                formLayout='flowV2'
                customClass='Custom-ETA'
                showColumnsHelp={true}
                hiddenColumns={['freigegeben', 'bemerkung']}
                customFormatter={this.customFormatter}
                enableRowCheckbox={true}
                checkedRows={checkedRows}
                onRowSelect={this.onRowSelect}
                allCheckboxChecked={allCheckboxChecked}
            />
            {this.state.showSpinner && <WSpinner />}
        </div>;
    }

    customFormatter(field: string, value: any, data: any, row: any): any {
        let style: React.CSSProperties = {};
        if (data.freigegeben === 1) {
            style = { color: 'green', fontWeight: 'bold' };
        } else {
            style = { color: 'red' };
        }
        return <div style={style}>{value}</div>;
    }

    onRowSelect(row: any, selected: boolean, checkedRows: any): void {
        // console.log(row, selected, checkedRows);
        if (this.state.showSpinner) {
            return;
        }
        let selectedRows: number[] = [];
        if (row.tid === 'all') {
            selectedRows = this.state.dataRows;
        } else {
            selectedRows.push(row);
        }
        const saveList: any[] = [];
        selectedRows.forEach((row: any) => {
            const saveData = { ...row };
            if (saveData.tid < 0) {
                saveData.tid = 0;
            }
            saveData.freigegeben = selected === true ? 1 : 0;
            saveData.datum_letzte_aenderung = Math.round(new Date().getTime() / 1000);
            saveList.push(saveData);
        });
        if (saveList.length > 0) {
            this.setState({ showSpinner: true }, () => {
                this.dataService.saveDataList(IDs.ENT_EXTERNAL_ACCESS, saveList, (sql: string, suc: boolean) => {
                    this.setState({ showSpinner: false });
                    if (suc) {
                        this.triggerService.fire('reload', IDs.ENT_VSME_EXPORT);
                        this.loadData();
                    }
                }, IDs.MOD_ETOOL_ADMIN);
            });
        }
    }
}
